import React from 'react';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import ActionModal from 'components/common/modals/ActionModal';
import { colors, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { Duplicate } from '@insurancemenu/imenu-components-lib/dist/icons';
import { createStyles } from './styles';

const MarkAsStockModal = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    markAsStockModalStore: { showMarkAsStockModal, shortTemplateInfo, closeMarkAsStockModal, onMarkAsStock },
    browsingStore: { cart, currentProductLineId, getPortfolios, setLoading },
    userStore: { sponsorId, imAgencyId },
  } = useRootStore();

  const convertedTemplateInfo = toJS(shortTemplateInfo);
  const convertedCart = toJS(cart);

  const query = useQueryParams();
  const groupId = query.get('groupId') || '';

  const onMarkPlanAsStock = async (): Promise<void> => {
    // Close the modal immediately and display a spinner on the browsing page
    // until the updated portfolios are received.
    closeMarkAsStockModal();
    setLoading(true);
    await onMarkAsStock();
    if (currentProductLineId && convertedCart.id) {
      await getPortfolios({
        bc: convertedCart.lastUpdateBrowsingCriteria,
        rateSegment: convertedCart.rateSegment,
        sponsorId,
        agencyId: imAgencyId,
        productLineId: currentProductLineId,
        groupId,
      });
    }
    setLoading(false);
  };

  return (
    <ActionModal
      show={showMarkAsStockModal}
      title="Mark as Stock"
      subtitle={
        <p>
          You are about to mark
          <b className={classes.templateName}>{convertedTemplateInfo?.name || 'this'}</b> plan as stock.
        </p>
      }
      icon={<Duplicate width="5.6rem" color={colors.green[600]} />}
      actionButtonText="Continue"
      closeButtonText="Close"
      onClose={closeMarkAsStockModal}
      onAction={onMarkPlanAsStock}
    />
  );
});

export default MarkAsStockModal;
